<template>
  <div class="price-config">

    <el-button type="primary" @click="addPrice"> 新增 </el-button>
    <el-table :data="tableData" style="width: 100%" height="480px">
      <el-table-column prop="id" label="序号" align="center">
      </el-table-column>
      <el-table-column prop="usdPrice" label="美元价格" align="center" sortable :sort-method="sortPrice">
      </el-table-column>
      <!-- <el-table-column prop="countryCurrency" label="货币类型" align="center">
      </el-table-column> -->
      <el-table-column prop="operator" label="操作人" align="center">
      </el-table-column>
      <el-table-column prop="address" label="操作" align="center">
        <template slot-scope="scope" width="200px">
          <el-button type="primary" size="small" @click="editPrice(scope.row)"> 编辑 </el-button>
          <el-button type="danger" size="small" @click="delData(scope.row.id)"> 删除 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="isEdit ? '修改' : '新增'" :visible.sync="addVisible" width="500px" :append-to-body="true">
      <div style="margin-bottom: 20px;">
        <span>美元价格: </span><el-input type="text" v-model="addData.usdPrice"
          style="width: 300px;margin-right: 20px;"></el-input>
      </div>
      <!-- <div>
        <span>货币类型: </span><el-input type="text" v-model="addData.countryCurrency"
          style="width: 300px;margin-right: 20px;"></el-input>
      </div> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPriceList, addPriceList, delPriceList } from '../../api/priceRequest'
export default {
  data() {
    return {
      tableData: [],
      addVisible: false,
      addData: {
        usdPrice: '',
        // countryCurrency: ''
      },
      isEdit: false
    }
  },
  methods: {
    sortPrice(a, b) {
      return a.usdPrice - b.usdPrice
    },
    editPrice(row) {
      this.isEdit = true;
      this.addVisible = true;
      this.addData = {
        id: row.id,
        usdPrice: row.usdPrice,
        // countryCurrency: row.countryCurrency
      }
    },
    resetData() {
      this.addData = {
        usdPrice: '',
        // countryCurrency: ''
      }
    },
    async addPrice() {
      this.isEdit = false
      this.addVisible = true
      this.resetData()
      // const res = await addPriceList({
      //   ...this.addData
      // })
      // console.log(res);
    },
    async submitAdd() {
      if (this.addData.usdPrice.trim() === '' || isNaN(Number(this.addData.usdPrice.trim()))) {
        return this.$message.error('数据不能为空，价格必须填数字')
      }
      const res = await addPriceList({
        data: this.addData
      })
      if (res.code == 0) {
        this.$message.success(res.msg)
        this.addVisible = false
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async getList() {
      const res = await getPriceList()
      if (res.code === 0) {
        this.tableData = res.data.list
      }
    },
    async delData(id) {
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await delPriceList(id)
        if (res.code == 0) {
          this.$message.success(res.msg)
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
      });
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style scoped lang="scss"></style>
